import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isBuyThereItem, isFamilyChecklistKind, isItemMissingCoverage, isMyFamilyChecked, } from "@/lib/planAssign";
/**
 * Virtual smart collections — references over items, never categories. "לקנות שם"
 * is the primary one (item-level fulfillment flag), alongside coverage/completion
 * views. Ordering here also drives the collection-detail predicate lookup.
 */
export const COLLECTIONS = [
    {
        id: "buy_there",
        title: "לקנות שם",
        icon: "🛒",
        description: "פריטים שמתוכננים להיקנות במקום",
        predicate: (item) => isBuyThereItem(item),
    },
    {
        id: "missing",
        title: "חסר שיוך / חסר כיסוי",
        icon: "⚠️",
        description: "פריטים ללא מי שאחראי עליהם",
        // Family-checklist items track per-family packing, never coverage.
        predicate: (item, ctx) => !isFamilyChecklistKind(ctx.sectionKind) && isItemMissingCoverage(item),
    },
    {
        id: "open",
        title: "לא נארזו",
        icon: "⏳",
        description: "פריטים שעדיין לא סומנו כנארזו",
        // For family checklists "not packed" means the current family hasn't packed.
        predicate: (item, ctx) => isFamilyChecklistKind(ctx.sectionKind)
            ? !isMyFamilyChecked(item, ctx.myParticipantId, ctx.myDisplayName)
            : !item.checked,
    },
];
export function getCollectionDef(id) {
    return COLLECTIONS.find((c) => c.id === id);
}
export function CollectionsTab({ content, myDisplayName, myParticipantId, onSelect, onSelectSection, }) {
    const shoppingSections = content.sections.filter((s) => s.sectionKind === "shopping");
    /** Count items across all sections matching a collection, with section context. */
    function collectionCount(def) {
        let count = 0;
        for (const section of content.sections) {
            const ctx = {
                sectionKind: section.sectionKind,
                myParticipantId,
                myDisplayName,
            };
            for (const sub of section.subsections) {
                for (const item of sub.items) {
                    if (def.predicate(item, ctx))
                        count += 1;
                }
            }
        }
        return count;
    }
    return (_jsxs("div", { className: "space-y-4", dir: "rtl", children: [_jsx("ul", { className: "space-y-2", children: COLLECTIONS.map((c) => {
                    const count = collectionCount(c);
                    return (_jsx("li", { children: _jsxs("button", { onClick: () => onSelect(c.id), className: "flex w-full items-center gap-3 rounded-2xl border border-slate-100 bg-white px-4 py-3 text-right shadow-sm transition-colors hover:border-indigo-300", children: [_jsx("span", { className: "text-2xl", "aria-hidden": true, children: c.icon }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "truncate text-sm font-semibold text-slate-800", children: c.title }), _jsx("p", { className: "truncate text-xs text-slate-400", children: c.description })] }), _jsx("span", { className: "shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500", children: count })] }) }, c.id));
                }) }), shoppingSections.length > 0 && (_jsxs("div", { children: [_jsx("h3", { className: "mb-2 px-1 text-xs font-semibold uppercase tracking-wide text-slate-400", children: "\u05E8\u05E9\u05D9\u05DE\u05D5\u05EA \u05E7\u05E0\u05D9\u05D5\u05EA" }), _jsx("ul", { className: "space-y-2", children: shoppingSections.map((section) => {
                            const itemCount = section.subsections.flatMap((s) => s.items).length;
                            return (_jsx("li", { children: _jsxs("button", { onClick: () => onSelectSection(section.id), className: "flex w-full items-center gap-3 rounded-2xl border border-slate-100 bg-white px-4 py-3 text-right shadow-sm transition-colors hover:border-indigo-300", children: [_jsx("span", { className: "text-2xl", "aria-hidden": true, children: section.icon || "🛒" }), _jsxs("div", { className: "flex-1 min-w-0", children: [_jsx("p", { className: "truncate text-sm font-semibold text-slate-800", children: section.title || "(ללא שם)" }), _jsxs("p", { className: "text-xs text-slate-400", children: [itemCount, " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD"] })] }), _jsx("svg", { className: "shrink-0 text-slate-300", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", "aria-hidden": true, children: _jsx("path", { d: "M10 4L6 8l4 4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })] }) }, section.id));
                        }) })] }))] }));
}
